import { useState, useCallback, useEffect } from 'react'

export const useVoiceoverHandler = ({ formData, setFormData }) => {
  const [showModeModal, setShowModeModal] = useState(false)
  const [showChangeModal, setShowChangeModal] = useState(false)
  const [pendingMode, setPendingMode] = useState(null)
  const [targetHasAudio, setTargetHasAudio] = useState(false)

  // Initialize modal visibility based on whether a mode has been saved
  useEffect(() => {
    if (!formData?.audioMode) {
      setShowModeModal(true)
    }
  }, [formData?.audioMode])

  const handleModeChange = useCallback(
    e => {
      const mode = e.target.value

      if (mode === formData?.audioMode) return

      const hasEasyAudio = formData?.shotList?.some(scene => !!scene.audio_link)

      const hasAdvancedAudio = formData?.shotList?.some(
        scene => !!scene.narration_audio_link || !!scene.dialogue_audio_link
      )

      const currentlyHasAudio = hasEasyAudio || hasAdvancedAudio
      const hasTargetAudio = mode === 'easy' ? hasEasyAudio : hasAdvancedAudio

      if (currentlyHasAudio) {
        setPendingMode(mode)
        setTargetHasAudio(hasTargetAudio)
        setShowChangeModal(true)
      } else {
        setFormData(prev => ({
          ...prev,
          audioMode: mode
        }))
      }
    },
    [setFormData, formData?.audioMode, formData?.shotList]
  )

  const handleConfirmMode = useCallback(() => {
    if (formData?.audioMode) {
      setShowModeModal(false)
    }
  }, [formData?.audioMode])

  const handleModeChangeCancel = useCallback(() => {
    setShowChangeModal(false)
    setPendingMode(null)
  }, [])

  const handleModeChangeContinue = useCallback(() => {
    setFormData(prev => ({
      ...prev,
      audioMode: pendingMode
    }))
    setShowChangeModal(false)
    setPendingMode(null)
  }, [pendingMode, setFormData])

  const handleModeChangeRegenerate = useCallback(() => {
    setFormData(prev => {
      const updatedShotList = (prev.shotList || []).map(scene => ({
        ...scene,
        audio_link: null,
        narration_audio_link: null,
        dialogue_audio_link: null,
        shots: scene.shots?.map(shot => {
          const {
            audio_link,
            narration_audio,
            dialogue_audio,
            narration_audio_link,
            dialogue_audio_link,
            ...restShot
          } = shot
          return {
            ...restShot,
            audio_duration: null
          }
        })
      }))

      return {
        ...prev,
        audioMode: pendingMode,
        shotList: updatedShotList
      }
    })
    setShowChangeModal(false)
    setPendingMode(null)
  }, [pendingMode, setFormData])

  const audioMode = formData?.audioMode || ''

  return {
    handleModeChange,
    handleConfirmMode,
    audioMode,
    showModeModal,
    showChangeModal,
    pendingMode,
    targetHasAudio,
    handleModeChangeCancel,
    handleModeChangeContinue,
    handleModeChangeRegenerate
  }
}
